class NewsLetter{
    constructor({ id = "", email, firstname, lastname, message }) {
        this.id = id;
        this.email = email;
        this.firstname = firstname
        this.lastname = lastname
        this.message = message
    }

    toFirestore() {
        return {
            email: this.email,
            firstname : this.firstname,
            lastname : this.lastname, 
            message : this.message, 
        }
    }

    static fromFirestore(snapshot) {
        const data = snapshot.data();
        return new NewsLetter({ 
            id: snapshot.id, 
            email: data.email, 
            firstname: data.firstname, 
            lastname: data.lastname,
            message: data.message,
        });
    }
}

export default NewsLetter;

